var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserAskAppointment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 47,
    viewBox: "0 0 49 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1098_175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.52273 0V5.29592C9.52273 5.35621 10.2356 6.07473 10.3388 6.12497C11.2188 6.53699 12.5708 5.81847 12.5708 4.8839V0H35.9868V5.08991C35.9868 5.8436 37.4567 6.48674 38.2187 6.12497C38.322 6.07473 39.0348 5.35621 39.0348 5.29592V0H44.423C44.5017 0 46.2666 0.417041 46.4583 0.502459C47.2744 0.879303 48.7935 2.72835 48.7935 3.6378V10.3909H0V3.22076C0 2.20077 1.72559 0 3.1513 0H9.52273Z",
    fill: "#19147E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49 43.1059V13.7121H0V43.729C0 44.9902 2.2123 47.0251 3.55935 46.9498C8.86075 46.8716 14.1784 46.9128 19.4965 46.9539C28.1993 47.0212 36.9032 47.0885 45.539 46.6332C46.7385 46.3368 49 44.3822 49 43.1059ZM21 20H27V27.5H34.5V33.5H27V41H21V33.5H13.5V27.5L21 27.5V20Z",
    fill: "#19147E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1098_175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 47,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAskAppointment);
export default __webpack_public_path__ + "static/media/user-ask-appointment.cb3d5bfe21c0477afb3203afce4191ff.svg";
export { ForwardRef as ReactComponent };